var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box_title_area",attrs:{"id":_vm.anchorId}},[_c('h3',{staticClass:"service-title-b"},[_vm._t("default")],2),_vm._v(" "),_c('p',[_vm._t("sub-title")],2),_vm._v(" "),_vm._t("additional")],2)}
var staticRenderFns = []

export { render, staticRenderFns }